<template>
  Stammdaten
  <div>
    <router-view />
  </div>
  <!--select class="form-select-sm" v-model="selectedMandant" @change="getMandant">
    <option v-for="(item , idMandant) in mandant.records" v-bind:key="idMandant">
      {{item.NameMandant}}
    </option>
  </select>
  <select class="form-select-sm" v-model="selectedBereich" @change="getBereich">
    <option v-for="(item , idBereich) in bereich.records" v-bind:key="idBereich">
      {{item.NameBereich}}
    </option>
  </select-->
</template>
<script language="ts">
import { reactive, ref } from "vue";
import { apiPost } from "@/services/api/fetchapi";
import { useStore } from "vuex";
import router from "@/router/index";


export default {
  name: "Stammdaten",
  inheritAttrs: false,
  components: {
  },
  setup() { 
    const store = useStore();
    const selectedMandant = ref("");
    const selectedBereich = ref("");
    const mandant = reactive({
      records: []
    });
    const bereich = reactive({
      records: []
    });

    function getMandant() {
      //await getBereiche();
      console.log("RefreshRouterView");
    }

    function getBereich() {
      //selectedBereich
      console.log("RefreshRouterView");
    }

    // async function getMandanten() {
    //   const response = await apiPost("ComponentView/getMandanten", {
    //     userId: store.getters["userstore/getUser"]
    //   });
    //   mandant.records = JSON.parse(JSON.stringify(response));
    // }

    // async function getBereiche() {
    //   const response = await apiPost("ComponentView/getBereiche", {
    //     userId: store.getters["userstore/getUser"],
    //     mandantName: selectedMandant.value,
    //   });
    //   bereich.records = JSON.parse(JSON.stringify(response));
    // }

    // getMandanten();

    router.push({name: "People"});

    return {
      selectedMandant,
      selectedBereich,
      mandant,
      bereich,
      getMandant,
      getBereich,
    }
  }
}
</script> 